import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { HttpClient } from '@angular/common/http';
import { AuthService, ResponseObject } from './auth.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { InstagramAccount,FacebookPostPublish, FacebookAccount } from '../models/socialpost.model';


@Injectable({
  providedIn: 'root'
})
export class FacebookService extends ServiceBase{
    private api = '/Facebook'

    constructor(private http: HttpClient,
        authService: AuthService) { 
          super(authService);
    }
  
    public onloginWithFacebook(): Observable<ResponseObject>{
      var httpOptions = this.RequestHeaders();
      const method: string = '/login-with-facebook';
      const url: string = environment.BASE_API_PATH + this.api + method;
      return this.http.get<ResponseObject>(url, httpOptions);
    }
  
    public onFacebookAccountsCallBack(code: string,state: string): Observable<ResponseObject>{
      var httpOptions = this.RequestHeaders();
      const method: string = '/callback-to-store-token';
      const url: string = environment.BASE_API_PATH + this.api + method;
      console.log(code,state)
      return this.http.post<ResponseObject>(url,{ code,state }, httpOptions);
    }
  
    public onPostPublish(savePost: FacebookPostPublish): Observable<ResponseObject>{
      var httpOptions = this.RequestHeaders();
      const method: string = '/publish-your-post';
      const url: string = environment.BASE_API_PATH + this.api + method;
      return this.http.post<ResponseObject>(url,savePost, httpOptions);
    }
  
    public onGetConnectedFacebookAccounts() : Observable<InstagramAccount>{
      var httpOptions = this.RequestHeaders();
      const method: string = '/fetch-connected-accounts';
      const url: string = environment.BASE_API_PATH + this.api + method;
      return this.http.get<InstagramAccount>(url, httpOptions);
    }
  
    public onGetAllFacebookAccounts() : Observable<FacebookAccount>{
      var httpOptions = this.RequestHeaders();
      const method: string = `/fetch-all-accounts`;
      const url: string = environment.BASE_API_PATH + this.api + method;
      return this.http.get<FacebookAccount>(url, httpOptions);
    }
  
    public onDeactiveAllAccount(): Observable<ResponseObject>{
      var httpOptions = this.RequestHeaders();
      const method: string = '/Disconnect-all-ccount';
      const url: string = environment.BASE_API_PATH + this.api + method;
      return this.http.delete<ResponseObject>(url,httpOptions);
    }
  
    public onDeactiveAccount(id : string): Observable<ResponseObject>{
      var httpOptions = this.RequestHeaders();
      const method: string = `/Disconnect-account/${id}`;
      const url: string = environment.BASE_API_PATH + this.api + method;
      return this.http.delete<ResponseObject>(url, httpOptions);
    }

    public deleteFacebookMetaData(username: string, password: string): Observable<ResponseObject> {
      var httpOptions = this.RequestHeaders();
      const method: string = `/DeleteMetaRequest`;
      const url: string = environment.BASE_API_PATH + this.api + method;
      const body = { username, password };
      return this.http.delete<ResponseObject>(url, { ...httpOptions, body });
  }
}
